var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "linkedin_svg__bg",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin_svg__fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8825 9.94126C11.8825 11.0134 11.0134 11.8825 9.94125 11.8825C8.86913 11.8825 8 11.0134 8 9.94126C8 8.86913 8.86913 8 9.94125 8C11.0134 8 11.8825 8.86913 11.8825 9.94126ZM20.6564 13.0302C20.5331 13.0148 20.4022 13.0071 20.2712 12.9994L20.2712 12.9994C18.3993 12.9224 17.3439 14.0317 16.9741 14.5093C16.874 14.6402 16.8278 14.7173 16.8278 14.7173V13.2922H13.6309V23.9537H16.8278H16.9741V20.7028V18.9464C16.9741 18.8638 16.9734 18.7805 16.9727 18.6968V18.6967C16.9672 18.0477 16.9616 17.3763 17.2823 16.7895C17.5904 16.2348 18.145 15.9575 18.769 15.9575C20.6178 15.9575 20.6564 17.6292 20.6564 17.7832V17.7986V23.9999H23.9996V17.0437C23.9996 14.6634 22.7902 13.2613 20.6564 13.0302ZM11.6129 13.2614H8.26964V23.9229H11.6129V13.2614Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;